class MerkzettelLadeindikator extends HTMLElement {
    constructor() {
        super();
    }

    init(container) {
        const template = document.querySelector('template[id="merkzettel-ladeindikator"]');
        const clone = template.content.cloneNode(true);
        const ladeindikator = clone.querySelector(".ladeindikator");
        this.appendChild(ladeindikator);
        container.appendChild(this);
    }

    show() {
        this.setAttribute("active", "");
    }

    hide() {
        this.removeAttribute("active");
    }

    remove() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    }
}

if (!customElements.get("merkzettel-ladeindikator")) {
    customElements.define("merkzettel-ladeindikator", MerkzettelLadeindikator);
}